import React, { useEffect } from "react";
import { roverAdded } from './action';
import {Redirect} from 'react-router-dom';
import {RoverSvg} from './partials/rover-svg';
import Pages from './enums/pages';
import CardButton from './components/cardButton';
import { AsideLayout } from './components/asideLayout';
import { Input, inputWIdth } from './components/input';
import { Checkbox } from './components/checkbox';
import RoutePlaningInfoModal from './modals/routePlaningInfo';
import RoverExtendedOptionsModal from  './modals/roverExtendedOptions';
import ValidationType from './enums/validationType';
import { IsReady } from './agent';
import ReactGA from "react-ga4";

const initWheelDistance = 2;
const initLength = 5;
const initTurningRadius = 8;

export function Rover(props) {
  const [fields, setFields] = 
    React.useState(
      {
        "wheelDistance": props.store.getState()?.rover?.wheelDistance ?? 0,
        "length": props.store.getState()?.rover?.length ?? 0,
        "turningRadius": props.store.getState()?.rover?.turningRadius ?? 0,
        "positionOfGnsReceiver": props.store.getState()?.rover?.positionOfGnsReceiver,
        "positionOfRotationAxis": props.store.getState()?.rover?.positionOfRotationAxis,    
      });

  const [errors, setErrors] = React.useState({});  
  const [showRoutePlaningInfoModal, setShowRoutePlaningInfoModal] =  React.useState(false);  
  const [extendedOptionsToggler, setExtendedOptionsToggler] = React.useState(props.store?.rover?.positionOfGnsReceiver || props.store?.rover?.positionOfRotationAxis);  
  const [showRoverExtendedOptionsModal, setShowRoverExtendedOptionsModal] = React.useState(false);   
  const [redirect, setRedirect] = React.useState(Pages.Rover);

  useEffect(() => {
    const unsubscribe =subscribeToStore();
    loadIsReady();
    if (!areRoverDataAlreadySet()) {
      setDefaultsToStore();
    }
    document.title = "Rover | Route Planning";
    return () => {
      unsubscribe();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }, []);

  function setDefaultsToStore() {
    props.store.dispatch(roverAdded({wheelDistance:initWheelDistance}));
    props.store.dispatch(roverAdded({length:initLength}));
    props.store.dispatch(roverAdded({turningRadius:initTurningRadius}));
  }

  function subscribeToStore() {
    return props.store.subscribe(() => {    
      setFields({
        "wheelDistance": props.store.getState().rover.wheelDistance,
        "length": props.store.getState().rover.length,
        "turningRadius": props.store.getState().rover.turningRadius,
        "positionOfGnsReceiver": props.store.getState().rover.positionOfGnsReceiver,
        "positionOfRotationAxis": props.store.getState().rover.positionOfRotationAxis
      })
    });
  }

  function areRoverDataAlreadySet() {
    return props.store.getState()?.rover && !isObjectEmpty(props.store.getState()?.rover);
  }

  function processNumber(value, min, max) {
    if (!value)
      return value;
    if (value < min)
      return min;
    if (value > max)
      return max;

    return value;
  }

  function handleValidation() {
    let error = {};
    return (checkValueIsSetOrAddError("wheelDistance", ValidationType.NumberGreaterThanZero, error)
      & checkValueIsSetOrAddError("length", ValidationType.NumberGreaterThanZero, error)
      & checkValueIsSetOrAddError("turningRadius", ValidationType.NumberGreaterThanZeroOrZero, error))
      & checkLowerThanLength("positionOfGnsReceiver", error)
      & checkLowerThanLength("positionOfRotationAxis", error, true);
  }

  function checkValueIsSetOrAddError(propertyName, validationType, error, setState = false) {
    let result = true;
    if (validationType === ValidationType.NumberGreaterThanZero) {
      if ((fields[propertyName] === "" || isNaN(fields[propertyName])) || parseFloat(fields[propertyName]) <= 0) {
        error[propertyName] = "Must be a number greater than zero.";
        result = false;
      }
    }
    else if (validationType === ValidationType.NumberGreaterThanZeroOrZero) {
      if ((fields[propertyName] === "" || isNaN(fields[propertyName])) || parseFloat(fields[propertyName]) < 0) {
        error[propertyName] = "Must be a number greater than or equal to 0.";
        result = false;
      }
    }
    if (setState && !isObjectEmpty(error))
      setErrors(error);
    return result;
  }

  function checkLowerThanLength(propertyName, error, setState = false) {
      let result = true;
 
      if (!isNaN(fields[propertyName]) && !isNaN(fields["length"]) && parseFloat(fields[propertyName]) > parseFloat(fields["length"])) {
        error[propertyName] = "Must be shorter than or equal to the length.";
        result = false;
      }
      
      if (setState && !isObjectEmpty(error))
        setErrors(error);
      return result;
  }

  function isObjectEmpty(obj) {
    return obj
    && Object.keys(obj).length === 0
    && Object.getPrototypeOf(obj) === Object.prototype
  }

  function loadIsReady() {
    Promise.all([IsReady.testRequests()]).then(() => {
    })
    .catch(error => {
      //404
      setRedirect(Pages.Page500);
    });
  }

  if (redirect === Pages.Rover)
  {
      let isValid = !isObjectEmpty(errors);
      return   (  
        <>
          <div className='interactive-block'>
            <RoverSvg wheelDistance={fields["wheelDistance"]} length={fields["length"]} turningRadius={fields["turningRadius"]} />
          </div>
          {/* [BLOCK] Aside */}
          <AsideLayout header = {"Your rover"} >
            <div className="mb-7">
              <Input label = {"Rover width"} htmlFor = {"rowerWidth"} placeholder = {"Meters"} value = {fields["wheelDistance"]}
                  error = {errors["wheelDistance"]} unit = {"m"} store = {props.store}
                  onChange ={(e) => { props.store.dispatch(roverAdded({wheelDistance: processNumber(e.target.value, 0, 100)})) }}
              />
              <Input label = {"Rover length"} htmlFor = {"roverLength"} placeholder = {"Meters"} value = {fields["length"]}
                  error = {errors["length"]} unit = {"m"} store = {props.store}
                  onChange ={(e) => { props.store.dispatch(roverAdded({length:processNumber(e.target.value, 0, 100)})) } }
              />
              <Input label = {"Turning radius"} htmlFor = {"turningRadius"} placeholder = {"Meters"} value = {fields["turningRadius"]}
                  error = {errors["turningRadius"]} unit = {"m"} store = {props.store}
                  onChange ={(e) => { props.store.dispatch(roverAdded({turningRadius:processNumber(e.target.value, 0, 1000)})) }}                    
              />
              <Checkbox label = {"Extended options"} className="mt-4" htmlFor = {"extendedOptionsToggler"} value = {extendedOptionsToggler}
                onChange ={(e) => { 
                    setExtendedOptionsToggler(!extendedOptionsToggler);
                    setShowRoutePlaningInfoModal(false);
                    setShowRoverExtendedOptionsModal(false);
                  }
                }
                />
              {extendedOptionsToggler
                && (<div className="section-container form-section-block mt-2 collapse show" id="extendedOptions">
                  <Input label = {"Position of axis of rotation (from back)"} htmlFor = {"positionOfRotationAxis"} placeholder = {"Centimetres"} value = {fields["positionOfRotationAxis"]}
                      width = {inputWIdth.W75}
                      error = {errors["positionOfRotationAxis"]} unit = {"m"} store = {props.store}
                      onChange ={(e) => { props.store.dispatch(roverAdded({positionOfRotationAxis:processNumber(e.target.value, 0, 100)})) }}                    
                  />

                  <Input label = {"Position of GNSS receiver (from back)"} htmlFor = {"positionOfGnsReceiver"} placeholder = {"Centimetres"} value = {fields["positionOfGnsReceiver"]}
                      width = {inputWIdth.W75}
                      error = {errors["positionOfGnsReceiver"]} unit = {"m"} store = {props.store}
                      onChange ={(e) => { props.store.dispatch(roverAdded({positionOfGnsReceiver:processNumber(e.target.value, 0, 100)})) }}                    
                  />
                  <button type="button" className="btn btn-blank text-fade-color mt-2" onClick = {(e) => {
                          setShowRoverExtendedOptionsModal(true);
                          setShowRoutePlaningInfoModal(false);                    
                        }
                      }
                    >
                    <i className="icon icon-info-circle h4-font-size mr-2" />
                    Help
                  </button>
                </div>
                  )}        
            </div>   
            <div>
              <div className="d-flex justify-content-between align-items-baseline">
                <h2 className="h4-font-size subtitle">Choose generator</h2>
                <button type="button" className="btn btn-blank h4-font-size text-fade-color" onClick = {(e) => {
                    setShowRoutePlaningInfoModal(true);
                    setShowRoverExtendedOptionsModal(false);                  
                  }
                }>
                  <i className="icon icon-info-circle" />
                </button>
              </div>
              {/*card buttons*/}
              <div className="aside-content d-grid grid-autofill-3 grid-gap-2">
                {<CardButton  label= {"Field"} img= {"btn-field.png"} alt = {"Fill a field"}
                  enabled = {isValid} linkTo = {Pages.Field} onClick = {handleValidation}             
                />}
                <CardButton  label= {"Obstacles"} img= {"btn-obstacles.png"} alt = {"Find the best route"}
                  enabled = {isValid} linkTo = {Pages.Obstacles} onClick = {handleValidation}    
                />
                <CardButton label= {"Points"} img= {"btn-points.png"} alt = {"Route through points"}
                  enabled ={isValid} linkTo = {Pages.Points} onClick = {handleValidation}    
                />                                                    
              </div>
            </div>
            <div className="section-group mt-4">                              
          </div>
          </AsideLayout>  
          <RoutePlaningInfoModal show = { showRoutePlaningInfoModal } hideAction = { () => {setShowRoutePlaningInfoModal(false)}}/>
          <RoverExtendedOptionsModal  show = { showRoverExtendedOptionsModal } hideAction = { () => {setShowRoverExtendedOptionsModal(false)}}/>
      </>);
    }
    else
      return <Redirect to={redirect} />
  };